function Window_OnResize(window, undefined) {
    if ($("#main-menu").offset() != undefined) {
        var width = Math.max(575, $(window).width() - $("#main-menu").offset().left - 30);
        $("#main-menu").width(width);
    } else {
        setTimeout(function() {
            Window_OnResize(window)
        }, 500);
    }

    var d = $(".category-details");
    for(var i=0;i<d.length;i++) {
    	SetFillers($(d[i]), {left: 0, right: 15});
    }

    setTimeout(function() {
    	SetFillers($("#featured-products"), {left: 0, right: 0}, $($("#featured-products").find(".flex-active-slide .name")));
    }, 10);
}

function SetFillers(container, padding, rightAnchor) {
    var leftBar = container.find(".transparent-bar-left");
    var rightBar = container.find(".transparent-bar-right");
	var offset = container.position().left;
    
	rightAnchor = rightAnchor || container;

    var x1 = -offset;
    var w1 = offset + padding.left;
    var x2 = parseFloat(rightAnchor.css("width"));
    var w2 = (document.body.clientWidth - (x2 + offset)) + padding.right;

	leftBar.css({left: x1,width: w1});
	rightBar.css({left: x2, width: w2});
}

function Flexslider_OnBeforeAnimate(slider) {
    if (slider.parent().get(0).id != "featured-products")
        return;
    var rightBar = slider.parent().find(".transparent-bar-right");

    var offset = slider.parent().position().left;    
    var w2 = document.body.clientWidth - offset;
    
    rightBar.css({left: 0, width: w2});
}

function Flexslider_OnAfterAnimate(slider) {
    if (slider.parent().get(0).id != "featured-products")
        return;
    var slide = slider.find(".flex-active-slide");
    if( slide.length == 0) slide = $(slider.find("li")[0]);

    SetFillers(slider.parent(), {left: 0, right: 0}, slide.find(".name"));
}

function Page_OnLocationChanged(newLocation) {
	var detail;
	switch(location) {
		case "minerals": detail = "#mineral-detail"; break;
		case "jewelry": detail = "#jewelry-detail"; break;
		case "fossils": detail = "#fossil-detail"; break;
		case "decor": detail = "#decor-detail"; break;
		case "about-us": ShowAboutUsPage(); return;
	}

	ShowCategoryDetail(document.body, detail);
}

function ShowAboutUsPage() {
	
}

function GetTransformationMatrix(obj) {
    var matrix = obj.css("-webkit-transform") || 
    obj.css("-moz-transform") || 
    obj.css("-ms-transform") || 
    obj.css("-o-transform") || 
    obj.css("transform");
    
    var re = /(-?[0-9.]+)/g;
    var m = matrix.match(re);
    matrix = [];
    
    for (var i = 0; i < m.length; i++)
        matrix.push(parseFloat(m[i]));
    return matrix;
}

function ShowCategoryDetail(button, category) {
	$(".category-details").hide();
	$(category).show();
	$("html,body").animate({scrollTop: $(category).offset().top}, "medium");	
	$(category).find(".button-back").off("click").on("click", function(e) {
		e.preventDefault();
		$("html,body").animate({scrollTop: $(button).offset().top}, "medium");
	});
	SetFillers($(category), {left: 0, right: 15});
}

$(window).on("resize", function() {
    Window_OnResize(this);
}).resize();

$(function() {
    Window_OnResize(window);
    Flexslider_OnAfterAnimate($("#featured-products .flexslider"));
    $('.flexslider').flexslider({
        animation: "slide",
        after: Flexslider_OnAfterAnimate,
        before: Flexslider_OnBeforeAnimate
    });

	$(".category-details").hide();

	$(".button-jewelry").click(function(e) { e.preventDefault(); ShowCategoryDetail(this, "#jewelry-detail"); });
	$(".button-fossil").click(function(e) { e.preventDefault(); ShowCategoryDetail(this, "#fossil-detail"); });
	$(".button-decor").click(function(e) { e.preventDefault(); ShowCategoryDetail(this, "#decor-detail"); });
	$(".button-mineral").click(function(e) { e.preventDefault(); ShowCategoryDetail(this, "#mineral-detail"); });

	if ("onhashchange" in window) { // event supported?
	    window.onhashchange = function () {
	        Page_OnLocationChanged(window.location.hash);
	    }
	}
	else { // event not supported:
	    var storedHash = window.location.hash;
	    window.setInterval(function () {
	        if (window.location.hash != storedHash) {
	            storedHash = window.location.hash;
	            Page_OnLocationChanged(storedHash);
	        }
	    }, 100);
	}

});
